// Number and period formatting of the report analysis steps (SAR amounts, counts, months), per language.
const locale = (lang) => (lang === "ar" ? "ar-SA" : "en-US");

export const money = (value, lang) => new Intl.NumberFormat(locale(lang), { style: "currency", currency: "SAR", maximumFractionDigits: 2 }).format(value);
export const count = (value, lang) => new Intl.NumberFormat(locale(lang)).format(value);

// { year, month } -> "September 2026" / "سبتمبر ٢٠٢٦" (Gregorian). A yearless source month shows the month only.
export function periodLabel(period, lang) {
  if (!period?.month) return "—";
  const date = new Date(Date.UTC(period.year || 2000, period.month - 1, 15));
  const options = period.year ? { month: "long", year: "numeric", timeZone: "UTC" } : { month: "long", timeZone: "UTC" };
  return new Intl.DateTimeFormat(lang === "ar" ? "ar-SA-u-ca-gregory" : "en-GB", options).format(date);
}
